import { render, staticRenderFns } from "./SelectCarrier.vue?vue&type=template&id=fefbe532&scoped=true"
import script from "./SelectCarrier.vue?vue&type=script&lang=js"
export * from "./SelectCarrier.vue?vue&type=script&lang=js"
import style0 from "./SelectCarrier.vue?vue&type=style&index=0&id=fefbe532&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fefbe532",
  null
  
)

export default component.exports